export const SET_ALERTS_TODAY = "SET_ALERTS_TODAY";
export const SET_CALENDAR_EVENTS = "SET_CALENDAR_EVENTS";
export const SET_LAST_START_DATE = "SET_LAST_START_DATE";
export const SET_LAST_END_DATE = "SET_LAST_END_DATE";
export const SET_RESCHEDULE_REQUESTS = "SET_RESCHEDULE_REQUESTS";

